<template>
    <div>
        <v-menu v-model="menu" :close-on-content-click="false" max-width="290">
            <template v-slot:activator="{ on }">
                <!-- :label="$attrs.label"
                    :dense="$attrs.dense"
                    :outlined="$attrs.outlined"
                    :rules="$attrs.rules" -->
                <!-- :hide-details="hideDetails" -->
                <v-text-field
                    v-bind="$attrs"
                    :value="formattedDate"
                    append-icon="calendar_today"
                    :clearable="clearable"
                    @click:append="menu = true"
                    readonly
                    v-on="on"
                    @input="handleChange"
                ></v-text-field>
            </template>
            <v-date-picker :type="type" :value="value" @change="handleChange" :locale="$i18n.locale" :min="min" :max="max"></v-date-picker>
        </v-menu>
    </div>
</template>

<script>
import { formatDate } from '@/utils';

export default {
    props: {
        value: [Array, String],
        showDateFormat: [Array, String],
        clearable: {
            type: Boolean,
            default: true
        },
        type: {
            type: String,
            default: 'date'
        },
        min: {
            type: [String, null],
            default: null
        },
        max: {
            type: [String, null],
            default: new Date().toISOString()
        }
    },
    data() {
        return {
            menu: false
        };
    },
    computed: {
        formattedDate: {
            get() {
                const date = formatDate(this.value, this.showDateFormat);
                if (!date || this.type == 'date') return date;

                const [day, month, year] = date.split('.');
                return `${month}.${year}`;
            },
            set(val) {
                return formatDate(val, this.showDateFormat);
            }
        }
    },
    methods: {
        handleChange(v) {
            if (!v) {
                this.formattedDate = null;
            }
            this.menu = false;

            this.$emit('input', v);
            this.$emit('change');
        }
    }
};
</script>
